import { useQuery } from 'react-query'
import axios from 'axios'
import { getApiServer } from '../../utils/helpers'

export default function useKpi (id, state, startDate, endDate, previousStartDate, previousEndDate, timezone) {
  return useQuery(['kpi', id, state, startDate, endDate, previousStartDate, previousEndDate], async () => {
    const kpi = await axios.post(`${getApiServer()}/kpis/${id}`, { state, startDate, endDate, previousStartDate, previousEndDate, timezone }, { withCredentials: true })
    return kpi.data
  }, {
    staleTime: Infinity,
    cacheTime: Infinity,
    retry: 0,
    keepPreviousData: true,
    enabled: false
  })
}